import React from 'react';
import { SearchIcon, BellIcon, MoonIcon, SunIcon, CommandIcon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { motion } from 'framer-motion';
interface NavbarProps {
  onCommandOpen: () => void;
}
export function Navbar({
  onCommandOpen
}: NavbarProps) {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <header className="h-16 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 flex items-center justify-between px-6" data-id="element-48">
      <button onClick={onCommandOpen} className="flex items-center gap-3 px-4 py-2 rounded-xl bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors group" data-id="element-49">
        <SearchIcon className="w-4 h-4 text-gray-400" data-id="element-50" />
        <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-51">
          Search or jump to...
        </span>
        <kbd className="hidden sm:flex items-center gap-1 px-2 py-1 text-xs bg-white dark:bg-gray-900 rounded border border-gray-300 dark:border-gray-700" data-id="element-52">
          <CommandIcon className="w-3 h-3" data-id="element-53" />K
        </kbd>
      </button>
      <div className="flex items-center gap-3" data-id="element-54">
        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="relative p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" data-id="element-55">
          <BellIcon className="w-5 h-5 text-gray-600 dark:text-gray-400" data-id="element-56" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-purple-600 rounded-full" data-id="element-57"></span>
        </motion.button>
        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={toggleTheme} className="p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" data-id="element-58">
          {theme === 'light' ? <MoonIcon className="w-5 h-5 text-gray-600" data-id="element-59" /> : <SunIcon className="w-5 h-5 text-gray-400" data-id="element-60" />}
        </motion.button>
        <div className="flex items-center gap-3 pl-3 border-l border-gray-200 dark:border-gray-800" data-id="element-61">
          <div className="text-right hidden sm:block" data-id="element-62">
            <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-63">
              Sarah Chen
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-64">
              Local Coffee Shop
            </p>
          </div>
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center text-white font-semibold" data-id="element-65">
            SC
          </div>
        </div>
      </div>
    </header>;
}